export default __webpack_public_path__ + "static/media/Hundred2.6898442b.jpeg";